export default {
  dp: {
    navbar: {
      language: 'Idioma',
      locales: {
        en_CA: 'English [CA]',
        en_US: 'English [US]',
        es_US: 'Español [US]',
        fr_CA: 'Français [CA]',
      },
    },
  },
};
